import useBbbDeliveryStaff, {
  bbbDeliveryStaffConfigs,
} from './useDeliveryStaff'
import useBbbDisputeMetrics, {
  bbbDisputeMetricsConfigs,
} from './useDisputeMetrics'
import useBbbDisputeReason, {
  bbbDisputeReasonConfigs,
} from './useDisputeReason'
import useBbbListLocationGroupDeliveryData, {
  bbbListLocationGroupDeliveryDataConfigs,
} from './useListLocationGroupDeliveryData'
import useBbbMissingItem, { bbbMissingItemConfigs } from './useMissingItem'

export const configs = {
  bbbListLocationGroupDeliveryData: bbbListLocationGroupDeliveryDataConfigs,
  bbbDisputeMetrics: bbbDisputeMetricsConfigs,
  bbbDisputeReason: bbbDisputeReasonConfigs,
  bbbMissingItem: bbbMissingItemConfigs,
  bbbDeliveryStaff: bbbDeliveryStaffConfigs,
}

export const api = {
  bbbListLocationGroupDeliveryData: useBbbListLocationGroupDeliveryData,
  bbbDisputeMetrics: useBbbDisputeMetrics,
  bbbDisputeReason: useBbbDisputeReason,
  bbbMissingItem: useBbbMissingItem,
  bbbDeliveryStaff: useBbbDeliveryStaff,
}
